export const pathPolygonViewer = 'polygon-viewer-dashboard';
